import React, { useState } from 'react';
import { parseNS3600Referanser, hentNS3600Info } from '../utils/ns3600-lenker';

/**
 * Komponent som viser tekst med klikkbare NS3600-referanser
 * @param {string} tekst - Teksten som skal vises
 * @param {string} className - Valgfri CSS-klasse
 */
function NS3600Tekst({ tekst, className }) {
  const [visModal, setVisModal] = useState(false);
  const [aktivReferanse, setAktivReferanse] = useState(null);

  const handleLenkKlikk = (referanse) => {
    const info = hentNS3600Info(referanse);
    if (info) {
      setAktivReferanse(info);
      setVisModal(true);
    }
  };

  const deler = parseNS3600Referanser(tekst, handleLenkKlikk);

  return (
    <>
      <span className={className}>
        {deler.map((del, index) => {
          if (del.type === 'lenke') {
            return (
              <span
                key={index}
                onClick={del.onClick}
                style={{
                  color: '#1976d2',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontWeight: '500'
                }}
                title="Klikk for å se mer informasjon"
              >
                {del.innhold}
              </span>
            );
          }
          return <span key={index}>{del.innhold}</span>;
        })}
      </span>

      {/* Modal for å vise NS3600-info */}
      {visModal && aktivReferanse && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: '20px'
          }}
          onClick={() => setVisModal(false)}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '8px',
              maxWidth: '600px',
              maxHeight: '80vh',
              overflow: 'auto',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
              <h3 style={{ margin: 0, color: '#1976d2', fontSize: '18px' }}>
                📘 {aktivReferanse.tittel}
              </h3>
              <button
                onClick={() => setVisModal(false)}
                style={{
                  background: 'none',
                  border: 'none',
                  fontSize: '24px',
                  cursor: 'pointer',
                  color: '#666',
                  padding: '0',
                  marginLeft: '15px'
                }}
              >
                ✕
              </button>
            </div>

            <div
              style={{
                whiteSpace: 'pre-line',
                lineHeight: '1.6',
                fontSize: '14px',
                color: '#333'
              }}
            >
              {aktivReferanse.innhold}
            </div>

            <div style={{ marginTop: '20px', paddingTop: '20px', borderTop: '1px solid #eee' }}>
              <button
                onClick={() => setVisModal(false)}
                style={{
                  backgroundColor: '#1976d2',
                  color: 'white',
                  border: 'none',
                  padding: '10px 20px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Lukk
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NS3600Tekst;
